import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";

/**
 * Passkey (WebAuthn) sign-in for the admin portal.
 *
 * Requires the admin Cognito pool to have passkeys enabled (WEB_AUTHN in
 * SignInPolicy) and the app client to allow USER_AUTH. signIn() detects that
 * at runtime by attempting InitiateAuth and treats a NotAuthorizedException /
 * missing challenge as "passkeys not enabled".
 */
@Injectable({ providedIn: "root" })
export class PasskeyService {
  constructor(private readonly auth: AuthService) {}

  async isAvailable(): Promise<boolean> {
    return typeof window !== "undefined" && !!window.PublicKeyCredential;
  }

  async signIn(): Promise<void> {
    throw new Error(
      "Passkey sign-in is not configured yet. Sign in with your password instead.",
    );
  }

  async addPasskey(): Promise<void> {
    throw new Error("Passkey registration is not available.");
  }
}
